import { style } from '@vanilla-extract/css';
import { recipe, RecipeVariants } from '@vanilla-extract/recipes';
import { DefaultReset, color, config, toRem } from 'folds';
import { elevoColor } from '../../../config.css';

export const PageNav = recipe({
  variants: {
    size: {
      '400': {
        width: toRem(232),
      },
      '300': {
        width: toRem(222),
      },
    },
  },
  defaultVariants: {
    size: '400',
  },
});
export type PageNavVariants = RecipeVariants<typeof PageNav>;

export const PageNavHeader = recipe({
  base: {
    padding: `0 ${config.space.S300}`,
    marginTop: config.space.S300,
    flexShrink: 0,
    selectors: {
      'button&': {
        cursor: 'pointer',
      },
      'button&[aria-pressed=true]': {
        backgroundColor: color.Background.ContainerActive,
      },
      'button&:hover, button&:focus-visible': {
        backgroundColor: color.Background.ContainerHover,
      },
      'button&:active': {
        backgroundColor: color.Background.ContainerActive,
      },
    },
  },

  variants: {
    modal: {
      true: {
        marginTop: config.space.S0,
      },
    },
    isDesktopMac: {
      true: {
        marginTop: config.space.S700,
      },
    },
  },
  defaultVariants: {
    modal: false,
    isDesktopMac: false,
  },
});
export type PageNavHeaderVariants = RecipeVariants<typeof PageNavHeader>;

export const PageNavContent = style({
  minHeight: '100%',
  padding: `${config.space.S200} 0 ${config.space.S700} ${config.space.S300}`,
});

export const PageHeader = recipe({
  base: {
    paddingLeft: config.space.S400,
    paddingRight: config.space.S200,
  },
  variants: {
    balance: {
      true: {
        paddingLeft: config.space.S200,
      },
    },
    outlined: {
      true: {
        borderBottomWidth: config.borderWidth.B300,
        borderBottomColor: elevoColor.Border.ExtremeLight,
      },
    },
    isMobileMac: {
      true: {
        paddingTop: 24,
        height: toRem(54 + 24),
      },
    },
  },
  defaultVariants: {
    outlined: true,
    isMobileMac: false,
  },
});
export type PageHeaderVariants = RecipeVariants<typeof PageHeader>;

export const PageContent = style([
  DefaultReset,
  {
    paddingTop: config.space.S400,
    paddingLeft: config.space.S400,
    paddingRight: 0,
    paddingBottom: toRem(100),
  },
]);

export const PageHeroEmpty = style([
  DefaultReset,
  {
    padding: config.space.S400,
    borderRadius: config.radii.R400,
    minHeight: toRem(450),
  },
]);

export const PageHeroSection = style([
  DefaultReset,
  {
    padding: '40px 0',
    maxWidth: toRem(466),
    width: '100%',
    margin: 'auto',
  },
]);

export const PageContentCenter = style([
  DefaultReset,
  {
    maxWidth: toRem(964),
    width: '100%',
    margin: 'auto',
  },
]);

export const PageMainFloating = style({
  backgroundColor: elevoColor.Background.Page,
  color: color.Surface.OnContainer,
  boxShadow: elevoColor.shadow.Page,
  border: `${config.borderWidth.B300} solid ${color.Surface.Container}`,
  borderRadius: config.radii.R500,
  overflow: 'hidden',
  margin: config.space.S400,
  marginLeft: config.space.S0,
});

export const PageMainSidePanel = style({
  width: `max(${toRem(456)}, 33vw)`,
  flexShrink: 0,
  flexGrow: 0,
});

export const PageMainNarrow = style({
  width: `max(${toRem(456)}, 33vw)`,
  flexShrink: 0,
  flexGrow: 0,
});
